import httpClient from './httpClient'

export default {
  async editPlayer(player) {
    let ret = await httpClient.post('/player', player)
    return ret
  },
  async getPlayer() {
    let ret = await httpClient.get('/player')
    return ret
  },
  async getVideoCurrentConfig(video_id) {
    let ret = await httpClient.get(`/player/?type=video&video_id=${video_id}`)
    return ret
  },
  async updateVideoCurrentConfig(
    video_id,
    bookMarks,
    ctas,
    outsideCta,
    videoRedirect,
    onFunnel
  ) {
    let ret = await httpClient.post('/player/?type=video', {
      video_id: video_id,
      bookMarks: bookMarks,
      ctas: ctas,
      outsideCta: outsideCta,
      videoRedirect: videoRedirect,
      onFunnel: onFunnel,
    })
    return ret
  },
  async updateVideoCurrentThumb({ video_id, thumb }) {
    let ret = await httpClient.post('/player/?type=video', {
      thumb,
      video_id,
    })
    return ret
  },
  async updateVideoConfig(data) {
    let ret = await httpClient.post('/player/?type=video', data)
    return ret
  },
  async updateAiVideoConfig(video_id, data) {
    let ret = await httpClient.post('/player/?type=video', {
      video_id: video_id,
      ai: data,
    })
    return ret
  },
  async addCta(video_id, data) {
    const ret = await httpClient.post(`/player/ctas/${video_id}`, data)
    return ret
  },
  async addOutsideCta(video_id, data) {
    const ret = await httpClient.post(
      `/player/ctas/${video_id}/?type=outside`,
      data
    )
    return ret
  },
  async deleteOutsideCta(video_id, ctaId) {
    const ret = await httpClient.delete(
      `/player/ctas/${video_id}/?type=outside`,
      {
        data: { ctaId },
      }
    )
    return ret
  },
  async deleteCta(video_id, ctaId) {
    const ret = await httpClient.delete(`/player/ctas/${video_id}`, {
      data: { ctaId },
    })
    return ret
  },
  async updateVideoRetentionMarkers(video_id, retentionMarkers) {
    let ret = await httpClient.post('/player/?type=video', {
      video_id: video_id,
      retention_markers: retentionMarkers,
    })
    return ret
  },
}
